export interface CasherArgs {
   containerId: string;
   cellId: string;
   isActive: boolean;
}

export abstract class Casher<D> {
   readonly cellId: string;
   readonly containerId: string;


   constructor({ containerId, cellId, isActive }: CasherArgs) {
      this.cellId = cellId;
      this.containerId = containerId;

      if (isActive) {
         window.addEventListener('beforeunload', () => this.set());
      } else {
         this.clear();
      }
   }


   public apply() {
      const container = JSON.parse(localStorage.getItem(this.containerId)) || {};
      const cash: D = container[this.cellId];

      if (!cash) { // #Absent cash #
         return null;
      }

      try {
         this.restore(cash);
      } catch(e) {
         console.error(`Cash error: `, e);
         this.clear();
      }
   }

   
   private set() {
      const container = JSON.parse(localStorage.getItem(this.containerId)) || {};
      container[this.cellId] = this.save();
      localStorage.setItem(this.containerId, JSON.stringify(container));
   }


   protected clear() {
      let container = JSON.parse(localStorage.getItem(this.containerId)) || {};
      delete container[this.cellId];
      localStorage.setItem(this.containerId, JSON.stringify(container));
   }


   protected abstract save(): D;
   protected abstract restore(cash: D): void;
}